import { PseudoComponent } from './../base-components/pseudo-component/pseudo.component';
import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CanActivateFalseGuard implements CanActivate{
    canActivate(component: PseudoComponent): boolean {
        return false;
    }
}